"use client";

import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/utils/lib";

const labelVariants = cva(
  `
    text-sm leading-none font-medium text-muted-foreground
    peer-disabled:cursor-not-allowed peer-disabled:opacity-70
  `,
);

const Label = ({
  ref,
  className,
  ...props
}: React.ComponentProps<"label"> & VariantProps<typeof labelVariants>) => (
  <label ref={ref} className={cn(labelVariants(), className)} {...props} />
);
Label.displayName = "Label";

export { Label };
